import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  rating: number;
  totalStars?: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function StarRating({
  rating,
  totalStars = 5,
  className,
  size = "md",
}: StarRatingProps) {
  const sizeClass =
    size === "sm"
      ? "tw:size-3"
      : size === "md"
        ? "tw:size-4"
        : size === "lg"
          ? "tw:size-5"
          : "";
  return (
    <div className={cn("tw:flex tw:items-center tw:gap-0.5", className)}>
      {Array.from({ length: totalStars }).map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= rating;

        return (
          <Star
            key={index}
            className={sizeClass}
            style={
              isFilled
                ? {
                    fill: "#F6A7AB",
                    color: "#F6A7AB",
                  }
                : { fill: "#e5e7eb", color: "#e5e7eb" }
            }
          />
        );
      })}
    </div>
  );
}
